const json = {
  projects: [
    {
      projectTitle: "BikePlay",
      projectDescription:
        "Acted as Product Manager and Software Lead to develop, in a team of 4, an augemented-reality bike accessory that projects directions into the user's field-of-view.",
      projectLabels: ["Python", "VR", "User Experience"],
      projectSource: "https://github.com/Picozzi/BikePlay",
      projectApp: "https://bikeplay.squarespace.com",
      projectImage:
        "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/projects/BikePlay_Logo_Black.png",
    },
    // {
    //   projectTitle: "EV & Go",
    //   projectDescription:
    //     "A web application that surveys users on their existing car needs and presents them with EV (electric vehicle) alternative to help accelerate and ease the transition to electrical vehicles. Conducted User Experience Analysis using primary UX Research methods.",
    //   projectLabels: ["Python", "Flask", "React"],
    //   projectSource:
    //     "https://drive.google.com/file/d/1cxuDH1Wsw7hT3SZoC6zAdm7pc0tRTEy2/view?usp=share_link",
    //   projectApp: "https://evandgo.onrender.com",
    //   projectImage:
    //     "https://picozziwebsite.s3.ca-central-1.amazonaws.com/images/projects/evandgo.png",
    // },
  ],
};

export default json;
